module.exports = "<template> <address-selector value.bind=field.value config.two-way=field></address-selector> </template> ";